import React from "react";
import { TextField, InputAdornment } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

const SearchBar = ({ onSearch }) => {
  const handleChange = (event) => {
    onSearch(event.target.value);
  };

  return (
    <TextField
      placeholder="Search here"
      variant="outlined"
      size="small"
      onChange={handleChange}
      sx={{
        ml: { xs: 0, sm: 0, md: 1, lg: 1, xl: 1 },
        width: { xs: "32%", sm: "32%", md: "250px", lg: "300px", xl: "300px" },
        flexShrink: { xs: 0, sm: 0, md: 0, lg: 0, xl: 0 },
        backgroundColor: (theme) =>
          theme.palette.mode === "dark"
            ? theme.palette.background.default
            : "#f9f9f9",
        "& .MuiOutlinedInput-root": {
          padding: { xs: "1px 6px", sm: "1px 7px", md: "1px 8px", lg: "1px 10px", xl: "1px 10px" },
          borderRadius: "12px",
          "& fieldset": {
            borderColor: (theme) => theme.palette.divider,
          },
          "&:hover fieldset": {
            borderColor: (theme) => theme.palette.primary.main,
          },
        },
        "& .MuiInputBase-input": {
          fontSize: { xs: "0.65rem", sm: "0.7rem", md: "0.72rem", lg: "0.75rem", xl: "0.75rem" },
          color: (theme) => theme.palette.text.primary,
        },
      }}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon
              sx={{ 
                color: (theme) => theme.palette.text.secondary,
                fontSize: { xs: "16px", sm: "18px", md: "19px", lg: "20px", xl: "20px" }
              }}
            />
          </InputAdornment>
        ),
      }}
    />
  );
};

export default SearchBar;
